import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["viewMode", "editMode", "textarea", "editButton"]

  startEdit(event) {
    event.preventDefault()

    // Hide view mode, show edit mode
    this.viewModeTarget.classList.add('hidden')
    this.editModeTarget.classList.remove('hidden')
    this.editButtonTarget.classList.add('hidden')

    // Store original content
    this.originalContent = this.textareaTarget.value

    // Focus textarea and select all text
    this.textareaTarget.focus()
    this.textareaTarget.select()
  }

  handleKeydown(event) {
    // Escape to cancel
    if (event.key === 'Escape') {
      event.preventDefault()
      this.cancelEdit()
    }

    // Enter (without shift) to save
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      this.saveEdit()
    }
  }

  cancelEdit() {
    // Restore original content
    this.textareaTarget.value = this.originalContent

    // Show view mode, hide edit mode
    this.viewModeTarget.classList.remove('hidden')
    this.editModeTarget.classList.add('hidden')
    this.editButtonTarget.classList.remove('hidden')
  }

  async saveEdit() {
    const newContent = this.textareaTarget.value.trim()

    if (!newContent) {
      alert('Message cannot be empty')
      return
    }

    if (newContent === this.originalContent) {
      // No changes, just cancel
      this.cancelEdit()
      return
    }

    const messageId = this.element.dataset.messageId
    const groupEdit = this.element.closest("[data-edit-url]")
    if (groupEdit) {
      try {
        const response = await fetch(groupEdit.dataset.editUrl, {
          method: 'PATCH',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({
            operation: 'edit_message',
            group_id: groupEdit.dataset.editGroupId,
            message_id: messageId,
            content: newContent
          })
        })
        if (!response.ok) {
          const error = await response.json()
          throw new Error(error.error || 'Unable to update the message.')
        }
        this.originalContent = newContent
        this.cancelEdit()
        this.element.dispatchEvent(new CustomEvent('group-intervention:sent', { bubbles: true }))
      } catch (error) {
        alert(`Failed to update message: ${error.message}`)
      }
      return
    }

    const conversationId = document.querySelector('[data-conversation-id]').dataset.conversationId

    // Get inloop and activity IDs from URL
    const pathParts = window.location.pathname.split('/')
    const inloopId = pathParts[pathParts.indexOf('inloops') + 1]
    const activityId = pathParts[pathParts.indexOf('activities') + 1]

    try {
      const response = await fetch(
        `/facilitator/inloops/${inloopId}/activities/${activityId}/conversations/${conversationId}/messages/${messageId}`,
        {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'text/vnd.turbo-stream.html',
            'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content
          },
          body: JSON.stringify({
            message: {
              content: newContent
            }
          })
        }
      )

      if (response.ok) {
        // Get the Turbo Stream response and let Turbo handle it
        const turboStream = await response.text()
        Turbo.renderStreamMessage(turboStream)
      } else {
        const errorData = await response.json()
        console.error('Failed to update message:', errorData)
        alert(`Failed to update message: ${errorData.errors ? errorData.errors.join(', ') : 'Unknown error'}`)
        this.cancelEdit()
      }
    } catch (error) {
      console.error('Error updating message:', error)
      alert('An error occurred while updating the message')
      this.cancelEdit()
    }
  }
}
